import { DialogComponent } from '@theme/dialog';

/**
 * The mobile filters drawer. Extends the shared DialogComponent so the
 * existing `showDialog` / `closeDialog` wiring keeps working, and adds
 * the one bit the base class doesn't know about: closing when the
 * inner <bottom-drawer> is dragged to dismiss (it dispatches
 * `bottom-drawer:close`, which bubbles up to here).
 */
class FacetsDrawer extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('bottom-drawer:close', this.closeDialog);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('bottom-drawer:close', this.closeDialog);
  }
}

if (!customElements.get('facets-drawer')) {
  customElements.define('facets-drawer', FacetsDrawer);
}
